export default __webpack_public_path__ + "static/media/checkIn2.97534b06.svg";